import React from 'react'
import logo5 from '../../assets/images/partner-logo1.png';
import logo2 from '../../assets/images/partner-logo2.png';
import logo1 from '../../assets/images/partner-logo3.png';
import logo3 from '../../assets/images/partner-logo4.png';
import logo4 from '../../assets/images/partner-logo5.png';
import logo6 from '../../assets/images/partner-logo6.png';
import logo7 from '../../assets/images/partner-logo7.png';
import logo8 from '../../assets/images/partner-logo8.png';
import logo9 from '../../assets/images/partner-logo9.png';
// import logo10 from '../../assets/images/partner-logo10.png';
import FinxRegistration from "../../components/mainpage/finxregistration/finxregistration";
import FAQPDF from "../../assets/pdf/ExpertMFD_FAQs.pdf";
import TC from "../../assets/pdf/T-C_ExpertMFD.pdf";
import POLICY from "../../assets/pdf/Policies_ExpertMFD.pdf";
import CP from "../../assets/pdf/Cookies-ExpertMFD.pdf";
import DC from "../../assets/pdf/Disclaimer_ExpertMFD.pdf";
import { Global_var } from "../../global/global_var";

function 
corporatesimage(props) {
    let uatUrl = "https://uatservices.expertmfd.com/thor-gateway-expertmfd"; //UAT
    let prodUrl = "https://services.expertmfd.com/thor-gateway-expertmfd"; //DNS  production --enable this for prod build
    let testUrl = "https://emfdmicro.njtechdesk.com/thor-gateway-expertmfd"; //DEV
    // "https://rcp.njtechdesk.com/?openModal=Register"     // TEST RCP
    // "https://uat.rcp.ciel.co.in/?openModal=Register"     // UAT RCP
    // "https://rcp.ciel.co.in/?openModal=Register"         // PROD RCP
    let testRcpUrl;
    if(Global_var.BASEURL === testUrl){
        testRcpUrl = "https://rcp.njtechdesk.com/?openModal=Register";
    } else if (Global_var.BASEURL === uatUrl){
        testRcpUrl = "https://uat.rcp.ciel.co.in/?openModal=Register";
    } else if(Global_var.BASEURL === prodUrl) {
        testRcpUrl = "https://rcp.ciel.co.in/?openModal=Register";
    }
    
    return (
        <React.Fragment>
            <section className="partners section-padding" id="ourpartners">
                <div className="container">
                    <div className="row">
                        <div className="section-title-white">
                            <h2>COLLABORATIVE PARTNERS</h2>
                            {/* <p>An affliate network future leaders</p> */}
                        </div>
                        <div className="col-md-12 col-sm-12 col-xs-12">
                            <div className="row">
                                <section className="customer-logos slider">
                                    <div className="slide"><a href="https://mutualfund.adityabirlacapital.com/" target="_blank"><img src={logo1} /></a></div>
                                    <div className="slide"><a href="https://www.axismf.com/" target="_blank"><img src={logo2} /></a> </div>
                                    <div className="slide"><a href="https://www.icicipruamc.com/" target="_blank"><img src={logo3} /></a></div>

                                    <div className="slide"><a href="https://www.ltfs.com/companies/lnt-investment-management/lnt-mutual-fund.html" target="_blank"><img src={logo4} /></a></div>
                                    <div className="slide"><a href="https://mf.nipponindiaim.com/" target="_blank"><img src={logo5} /></a></div>

                                    <div className="slide"><a href="https://www1.nseindia.com/" target="_blank"><img src={logo6} /></a></div>
                                    <div className="slide"><a href="https://www.sbimf.com/" target="_blank"><img src={logo7} /></a></div>
                                    <div className="slide"><a href="https://www.sundarammutual.com/" target="_blank"><img src={logo8} /></a></div>
                                    <div className="slide"><a href="https://www.hdfcfund.com/" target="_blank"><img src={logo9} /></a></div>
                                    {/* <div className="slide"><img src={logo10} /></div> */}
                                </section>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section class="sub-footer" id="subfooter">

                <div class="container">
                    <div class="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                        <div class="col-md-4 col-lg-4 col-sm-6 col-xs-12">
                            <div className="section-title-black">
                                <h3>ABOUT US</h3>
                            </div>
                            <p>“ExpertMFD” is a pan India, collaborative initiative to create Financial Entrepreneurs for the mutual fund
                                            industry.</p>
                            <div className="footer-btn">
                                <a href onClick={()=>{window.open(testRcpUrl,'_blank');}}>
                                    {/* data-keyboard="true" data-toggle="modal" data-target="#feat-Reg"> */}
                                    <button type="button" class="blue-btn"> LOGIN/REGISTER</button>
                                </a>
                            </div>
                        </div>
                        <div class="col-md-4 col-lg-4 col-sm-6 col-xs-12">
                            <div className="section-title-black">
                                <h3>QUICK MENU</h3>
                            </div>
                            <div className="quickMenu">
                                <ul>
                                    
                                    <li> <a href={TC} target="_blank" > Terms and Conditions </a></li>
                                    <li> <a href={POLICY} target="_blank" > Privacy Policy </a></li>
                                    <li> <a href={CP} target="_blank" > Cookie Policy </a></li>
                                    <li> <a href={DC} target="_blank" > Disclaimer </a></li>
                                    <li> <a href={FAQPDF} target="_blank" > FAQs </a></li>
                                </ul>
                            </div>
                        </div>
                        <div class="col-md-4 col-lg-4 col-sm-6 col-xs-12">
                            <div className="section-title-black">
                                <h3>SOCIAL MEDIA</h3>
                            </div>
                            <div className="socialLinks">
                                <a href="https://www.facebook.com/ciellearning" target="_blank"  class="fa fa-facebook"></a>
                                <a href="https://www.instagram.com/ciellearning/" class="fa fa-instagram" target="_blank" ></a>
                                <a href="https://www.linkedin.com/company/ciellearning" class="fa fa-linkedin" target="_blank" ></a>
                                <a href="https://twitter.com/ciellearning" class="fa fa-twitter" target="_blank" ></a>

                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* <FinxRegistration {...props} /> */}
        </React.Fragment>
    );
}

export default corporatesimage
